export const businessLicenseUrl = {
  root: (buyerId: number) => `/buyers/${buyerId}/business-license`,
};
